<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <div class="range-slider-container">
      <p>{{DV_title}}</p>
      <input 
        v-show="C_isVisible"
        :disabled="isTrue(P_disabled) || P_editing" 
        :style="C_sliderStyle" 
        :min="DV_min" 
        :max="DV_max" 
        :step="DV_step"
        v-model="DV_value"
        type="range" 
        class="G_range_slider" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: [
    "P_title", 
    "P_min", 
    "P_max", 
    "P_step",
    "P_value", 
    "P_vertical",
    'P_customCss'
  ],
  mixins: [bi10GridComponent],
  data () {
    return {
      // we can get this from prop
      DV_title: this.P_title || "Simple Slider",
      DV_min: this.P_min || 1,
      DV_max: this.P_max || 100,
      DV_step: this.P_step || 10,
      DV_value: this.P_value || 30,
    }
  },
  computed: {
    C_sliderStyle () {
      return {
        height: '100%',
        width: '100%',
        marginTop: '5px',
        marginLeft: '5px'
      }
    }
  },
  watch: {
    P_value() {
      this.DV_value = this.P_value || ""
    }
  }
}
</script>

<style>
.range-slider-container {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/GSlider.vue